module.exports = __webpack_public_path__ + "static/media/bmsce.0348e751.jpg";